<template>
  <div v-if="cardType == 'date' && date" class="info-card info-card--date">
    <Label
            class="font-bold"
            :label="date.format('dddd')"
    />
    <p class="xlarge">
      {{ date.format('DD') }}
      <sub>{{ date.format('MMM') }}</sub>
    </p>
  </div>
  <div v-else class="info-card info-card--icon" @click="handleAction()">
    <img :src="icon.url" alt="" class="icon info-card__icon">
    <div class="info-card__trigger font-bold">
      {{ text }}
    </div>

  </div>
</template>

<script>
import * as components from '@/icons'
import Label from '@/components/partials/Label.vue'
import Modal from '@/components/modals/Modal.vue'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'
import { EventBus, EVENTS } from '@/services/events/EventBus'
import actionHandler from '@/mixins/actionHandler.mixin'

export default {
  components: {
    ...components,
    Label,
    Modal,
    Wysiwyg
  },
  mixins: [actionHandler],
  props: {
    date: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    cardType: {
      type: String,
      default: 'link'
    },
    field_type: {
      type: Object,
      default: () => {}
    },
    modal: {
      type: String,
      default: ''
    },
    modal_header_image: {
      type: [Object, Boolean],
      default: false
    }
  },
  data() {
    return {
      openModal: false
    }
  },
  methods: {
    toggleModal() {
      console.log('toggle Modal')
      this.openModal = !this.openModal
    },
    openChat () {
      EventBus.$emit(EVENTS.OpenChat)
    }
  }
}
</script>

<style lang="scss">
.info-card {
  position: relative;
  color: $info-cards-color;
  padding: $info-card-padding;
  border: $info-cards-border;
  width: 50%;
  &:nth-of-type(4n + 2) {
    border-left: none;
  }
  &:nth-of-type(4n + 3) {
    border-top: 0;
  }
  &:nth-of-type(4n + 4) {
    border-top: 0;
    border-left: 0;
  }
  &--date {
    padding: $info-card-date-padding;
  }
  &__icon {
    width: $info-card-icon-size;
    height: $info-card-icon-size;
    margin-bottom: rem(10);
  }
  &__trigger {
    display: block;
    text-decoration: none;
    padding: 0;
    font-size: inherit;
    &:focus {
      outline: none;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}

  .icon {
        width: 24px;
        height: 24px;
        margin-right: 14px;
    }
</style>

<docs>
  ```vue
  <div class="background--dark row">
    <InfoCard card-type="link" :info="{ icon: 'destination', text: 'Wifi Code' }" />
    <InfoCard card-type="link" :info="{ icon: 'edit', text: 'Restaurant' }" />
  </div>
  ```
  ```scss
  // Variable defaults:
  $info-card-padding: 20px 20px 10px;
  $info-card-date-padding: $info-card-padding;
  $info-card-icon-size: 1.5rem;
  ```
</docs>
